<template>
  <Layout2 :ratio="'1.05fr 1fr'" id="push-selected">
    <template slot="left">
      <Info :info="info"/>
      <div id="l2">
        <div>選擇受眾</div>
        <RT :defaultValue="ft" :options="['所有會員', '會員群組']" @input="ft=$event"></RT>
        <div v-if="available<0" class="error">!注意: 您已超過預設上限 {{available*-1}} 人，可能須增加費用或變更減少受眾範圍。</div>
      </div>
      <Layout2 ratio="1fr 1fr" id="push-clients">
        <template slot="left">
          <div class="filter1" v-if="ft==='所有會員'">
            <SearchInput :width="'100%'" :placeholder="'LINE名稱 / 暱稱 / 會員ID / 聯絡電話'" :style="{paddingInline: '5px'}" :defaultValue="searchText" @search="searchText=$event"/>
            <div v-if="users" class="users" :class="users.length===0?'shownote':''" :label="'請輸入 LINE名稱 | 暱稱 | 會員ID | 聯絡電話 搜尋'" :label2="'輸入完成請按Enter開始搜尋'">
              <div v-for="user in users.filter(e => !usersSelected.map(u => u._id).includes(e._id))" :key="`userlist-${user._id}`">
                <div :style="{whiteSpace: 'nowrap', overflowX: 'hidden'}">{{user.lineName+(user.pause ? '(停用)' : '')}}</div>
                <button @click="usersSelected.push(user)" :style="{marginLeft: 'auto'}" class="selectbtn"></button>
              </div>
            </div>
          </div>
          <div class="filter1" v-else>
            <SearchInput :width="'100%'" :placeholder="'群組標籤名稱'" :style="{paddingInline: '5px'}" :defaultValue="searchTag" @input="searchTag=$event"/>
            <div v-if="users" class="users">
              <div v-for="(tag, t) in tagsF" :key="`tags-${t}`">
                <div :style="{whiteSpace: 'nowrap', overflowX: 'hidden'}">{{tag}}</div>
                <button @click="tagsSeleted.push(tag)" :style="{marginLeft: 'auto'}" class="selectbtn"></button>
              </div>
            </div>
          </div>
        </template>
        <div class="lr"><div>指定推播</div><div :style="{fontSize: '18px', fontWeight: 400}">預計傳送人數</div><div>約 <span>{{usersSelected.length}}</span> 人</div></div>
        <div class="usersout" :style="{flex:1,maxHeight: '100%'}">
          <div v-if="usersSelected" class="usersSelected">
            <div v-for="(tag, u) in tagsSeleted" :key="`tags-s-${u}`" :style="{backgroundColor: 'var(--color-pri)', color: '#FFFFFF', flexDirection: 'row-reverse'}">
              <div :style="{whiteSpace: 'nowrap', overflowX: 'hidden', maxWidth: '320px'}">{{tag}}</div>
              <button @click="tagsSeleted.splice(u, 1)" :style="{marginRight: 'auto', transform: 'rotate(180deg)'}" class="selectbtn"></button>
            </div>
            <div v-for="(user, u) in usersSelected" :key="`userlist-${user._id}`">
              <div :style="{whiteSpace: 'nowrap', overflowX: 'hidden', maxWidth: '320px'}">{{user.lineName+(user.pause ? '(停用)' : '')}}</div>
              <button @click="usersSelected.splice(u, 1)" :style="{marginLeft: 'auto'}" class="delbtn"></button>
            </div>
          </div>
        </div>
      </Layout2>
    </template>
    <Box @save="save" @saveAs="save($event, true)" :clear="clear" :processing="processing"/>
  </Layout2>
</template>

<script>
import { mapState } from 'vuex'
import Layout2 from '../../components/layout/La1.vue'
import { getapi, putapi } from '../../store/fetch'
import SearchInput from '../../components/input/search.vue'
import Box from './message/box.vue'
import Info from './message/lineinfobox.vue'
export default {
  props: ['info'],
  components: {
    Box,
    Info,
    SearchInput,
    Layout2
  },
  data () {
    return {
      clear: 0,
      ft: '所有會員',
      usersSelected: [],
      users: [],
      tags: [],
      searchText: null,
      searchTag: null,
      tagsSeleted: [],
      old: null,
      processing: false
    }
  },
  async mounted () {
    this.tagsSeleted = this.$route.query.tag ? [this.$route.query.tag] : []
    // await this.getUsers()
    const tags = await getapi('selections/user-tags')
    this.tags = tags || []
    if (this.$route.query.id) {
      const ref = await getapi(`message/${this.$route.query.id}`)
      console.log(ref, 'ref')
      if (ref) {
        this.usersSelected = ref.targets
        this.old = ref
      }
    }
  },
  computed: {
    tagsF () {
      const tags = this.tags.filter(e => !this.tagsSeleted.includes(e))
      if (this.searchTag) {
        return tags.filter(e => new RegExp(this.searchTag, 'ig').test(e))
      } else {
        return tags
      }
    },
    available () {
      return ((this.info.limitMax || 500) - (this.info.countUsed || 0)) - this.usersSelected.length
    },
    ...mapState({
      scanid: state => state.scanid
    })
  },
  watch: {
    async ft () {
      if (this.ft === '會員群組') {
        const tags = await getapi('selections/user-tags')
        this.tags = tags || []
      }
    },
    async tagsSeleted () {
      await this.getUsersByTags()
    },
    async searchText () {
      if (this.searchText) {
        await this.getUsers()
      } else {
        this.users = []
      }
    },
    async scanid () {
      if (this.scanid.length === 12) {
        // console.log(this.scanid.toUpperCase(), 'scanid')
        const user = await getapi(`users/line2/${this.scanid.toUpperCase()}`)
        if (user) {
          this.usersSelected.push(user)
        }
      }
    }
  },
  methods: {
    async save (ev, temp) {
      this.processing = true
      await this.wait(100)
      let type
      const content = {}
      switch (ev.messageType) {
        case '活動公告':
          switch (ev.type) {
            case '純文字':
              type = 'text'
              content.textContent = ev.content
              break
            case '純圖片':
              type = 'image'
              content.imageUrl = ev.content
              break
            case '圖文訊息':
              type = 'bubble'
              content.bubbleHeader = ev.content.title
              content.bubbleContent = ev.content.content
              content.bubbleImage = `${ev.content.image}`
              content.bubbleLink = ev.content.link
              break
          }
          break
        case '發送票券':
          type = 'coupon'
          content.coupon = ev.coupon._id
          break
        case '發送多張票券':
          type = 'multicoupons'
          content.coupons = ev.coupons.map(e => { return { ...e, coupon: e.coupon._id } })
          break
        case '發送票券並推播':
          switch (ev.type) {
            case '純文字':
              type = 'couponWithText'
              content.coupon = ev.coupon._id
              content.textContent = ev.content
              break
            case '純圖片':
              type = 'couponWithImage'
              content.coupon = ev.coupon._id
              content.imageUrl = ev.content
              break
          }
          break
        default:
          alert('ERROR')
          break
      }
      const url = `message/${type}${temp ? '/temp' : ''}`
      const targetFilters = { consume: '指定' }
      const to = ev.messageType === '活動公告' ? this.usersSelected.map(e => e.lineID) : this.usersSelected.map(e => e._id)
      if ((this.usersSelected?.length || 0) === 0) {
        alert('所選無客戶')
        console.log(url, { ...content, type, targetFilters, to, sendTime: this.sendTime ? this.moment(`${this.sendDate} ${this.sendTimeT}`).toISOString() : '' })
        return false
      }
      const r = await putapi(url, { ...content, type, targetFilters, to, sendTime: '' })
      console.log('[put][resp]', r)
      if (r) {
        alert(temp ? '儲存成功' : '發送成功')
        this.clear += 1
        this.tagsSeleted = []
        this.usersSelected = []
      } else if (r) {
        this.clear += 1
        this.tagsSeleted = []
        this.usersSelected = []
      }
      this.processing = false
    },
    async getUsersByTags () {
      const params = {}
      if (this.tagsSeleted && this.tagsSeleted.length > 0) {
        params.tags = this.tagsSeleted
      } else {
        params.tags = 'unkonwn'
      }
      const data = await getapi('users/line2?' + new URLSearchParams(params))
      this.usersSelected = data
    },
    async getUsers () {
      const params = {}
      if (this.searchText) {
        params.search = this.searchText
      }
      const data = await getapi('users/line2?' + new URLSearchParams(params))
      this.users = data
    }
  }

}
</script>

<style lang="scss">
#push-selected {
  &>.La1_left {
    border-right: 1px solid #CACACA;
    overflow-y: auto;
    padding: 18px 34px 38px;
  }
  &>.La1_right {
    overflow-y: auto;
  }
  #l2 {
    .radiobox {
      flex-wrap: nowrap;
      input[type=radio] {
        height: 45px;
        padding-inline: 30px;
        line-height: 23px;
        letter-spacing: 0;
        box-sizing: border-box;
      }
    }
  }
}
#push-clients {
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  max-height: calc(100vh - 283px);
  &>.La1_left {
    height: -webkit-fill-available;
    flex: 1;
    background: var(--color-bar);
    border-radius: 5px;
    padding: 16px;
    gap: 19px;
  }
  &>.La1_right {
    box-sizing: border-box;
    flex: 1;
    height: -webkit-fill-available;
    display: flex;
    flex-direction: column;
    grid-template-rows: 45px 1fr;
    &>div:nth-child(2) {
      margin: 4px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      flex: 1;
    }
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.selectbtn {
  width: 23px;
  height: 23px;
  background-color: var(--color-checked);
  border-radius: 3px;
  background-image: url(/arrow.svg);
  background-size: 14.38px;
  background-repeat: no-repeat;
  background-position: center;
}
.delbtn {
  width: 23px;
  height: 23px;
  background-color: #FFFFFF;
  border-radius: 3px;
  background-image: url(/delete.svg);
  background-size: 22px;
  background-repeat: no-repeat;
  background-position: center;
}
.usersout {
  flex: 1;
  height: calc(100% - 45px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 45px);
}
.users {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 5px;
  &.shownote::before {
    content: attr(label);
    color: #CACACA;
    letter-spacing: .05em;
  }
  &.shownote::after {
    content: attr(label2);
    color: #CACACA;
    letter-spacing: .1em;
  }
  &>div{
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    padding: 13px 14px 13px 25px;
    button {
    }
  }
}
.usersSelected {
  padding: 20px 14px;
  margin: 5px;
  overflow-y: auto;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  &>div{
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    padding: 13px 14px 13px 25px;
    button {
    }
  }
}
.lr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #787878;
  height: 45px;
  &>:nth-child(1) {
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: var(--color-pri);
  }
  &>:nth-child(3) {
    font-weight: 400;
    span {
      font-weight: 700;
      color: #FF7373;
    }
  }
}
.filter1 {
  border-radius: 5px;
  background: var(--color-bar);
  flex: 1;
  display: grid;
  grid-template-rows: 45px 1fr;
  max-height: 100%;
  gap: 19px;
  &>div:nth-child(2) {
    overflow-y: auto;
  }
}
.error {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0.1em;
  color: #FF7373;
}
#l2 {
  display: flex;
  margin-block: 16px 11px;
  align-items: center;
  font-weight: 400;
  font-size: 25px;
  line-height: 36px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  gap: 5px;
  white-space: nowrap;

}
</style>
